import { Fancybox } from '@fancyapps/ui';
Fancybox.bind('[data-fancybox]', {
    // Your custom options can be added here if needed
});
